/**
 * Thin federation-safe entry. Defers the actual bootstrap behind a dynamic
 * `import()` so webpack's Module Federation runtime can finish initializing
 * the shared scope + host container (`window.platform`) BEFORE any module
 * that consumes a federated remote evaluates.
 *
 * Why this shape and not just inline the bootstrap?
 *   - Webpack's federation host emits the platform container as a separate
 *     entry script. Without an async boundary, the host's main bundle runs in
 *     the SAME tick as the container script, and any synchronous
 *     `import { x } from 'platform/y'` in our tree races the
 *     `var platform = { get, init }` hoist. Under load, MFEs occasionally
 *     hit `Container missing while loading "./<expose>" from <id>` because
 *     `window.platform` is still undefined when their consume fires (Pini
 *     retries 3× before crashing).
 *   - The async `import('./bootstrap')` creates a chunk boundary; webpack
 *     awaits the federation runtime + share-scope init before evaluating it.
 *     This is the pattern documented under "Async script loading" in the
 *     ModuleFederationPlugin guide.
 *
 * Old: no direct match — new in v2 (legacy pp_admin loaded its bundles
 *      through AngularJS' own bootstrap, which had no ModFed coupling).
 */
import('./bootstrap');
